import {
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip as ReChartsTooltip,
    Scatter,
    ResponsiveContainer,
    ScatterChart,
    Label
} from 'recharts';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbErrorSection, bbIsObject,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor, isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import React from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Badge} from "reactstrap";
import {useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";

function CustomTooltip({ payload, label, active }) {
    // console.log("tip payload is", payload)
    try{
        if (active && payload && payload[0] && payload[0].payload) {

            const vectorLikelihoodToDisplay = payload[0].payload.scored_vector_likelihood_score !== 0.71 //if this is a manual override for a case with score of 1.0 and no vectors
                ? parseFloat(payload[0].payload.scored_vector_likelihood_score).toFixed(1)
                : "N/A";

            const vectorImpactToDisplay = payload[0].payload.scored_vector_impact_score !== 0.71 //if this is a manual override for a case with score of 1.0 and no vectors
                ? parseFloat(payload[0].payload.scored_vector_impact_score).toFixed(1)
                : "N/A";

            return (
                <Widget styleName={`p-1 px-2`}>

                    <h2 className="label">{`${payload[0].payload.name}`}</h2>
                    {/*{parseFloat(payload[0].payload.score) === 1 &&*/}
                    {/*<Badge color={bbTranslateBreachRiskScoreToColor(payload[0].payload.score)}><span style={{fontSize: "larger"}}>Most Dangerous Threat Detected</span></Badge>*/}
                    {/*}*/}
                    <h1 className="label">{`BreachRisk™ Score: ${parseFloat(payload[0].payload.score).toFixed(1)}`} <small className={'text-muted'}>/10</small></h1>

                    {/*<h4 className={"text-center"}>Risk Category:</h4>*/}
                    <p>
                        Threat Likelihood: <Badge>{vectorLikelihoodToDisplay} </Badge> Threat Impact <Badge> {vectorImpactToDisplay}</Badge>
                    </p>


                    <Badge color={bbTranslateBreachRiskScoreToColor(payload[0].payload.score)}><span style={{fontSize: "larger"}}>{bbTranslateBreachRiskScoreToCategory(payload[0].payload.score)} Risk</span></Badge>

                    <hr/>

                    <p className={'text-right'}>
                        <small>
                            <em>Threat ID: {`${payload[0].payload.id ? payload[0].payload.id : "N/A"}`}</em>
                        </small>

                    </p>

                    {/*<p className="intro">{getIntroOfPage(label)}</p>*/}
                    {/*<p className="desc">Anything you want can be displayed here.</p>*/}
                </Widget>
            );
        }

        return null;
    }catch(e){
        console.warn("Issue with 2D scatter payload", e);
        return null;
    }

}

// const bbTickFormatter = (input) => {
//     return bbFormattedDateString(input, 'micro');
// }

//looks for vectors with identical likelihoods, and spaces them horizontally so they can be moused over
const vectorDataSpacer = (data) => {
    if (data && Array.isArray(data)) {
        const pointsOrganizedByLikelihood = {};
        for (const point of data) {
            const impactHalfNotch = Math.round(point.scored_vector_impact_score*2)/2; //creates a notch to group impacts within the nearest half point
            if(!pointsOrganizedByLikelihood[point.scored_vector_likelihood_score]) {
                pointsOrganizedByLikelihood[point.scored_vector_likelihood_score] = {}
            }
            if(!pointsOrganizedByLikelihood[point.scored_vector_likelihood_score][impactHalfNotch]) {
                pointsOrganizedByLikelihood[point.scored_vector_likelihood_score][impactHalfNotch] = []
            }
            pointsOrganizedByLikelihood[point.scored_vector_likelihood_score][impactHalfNotch].push(point);
        }
        // console.log("organized vectors by likelihood score", pointsOrganizedByLikelihood);

        //now, go through each member and adjust likelihood slightly
        const keys = Object.keys(pointsOrganizedByLikelihood);
        for (const likelihoodCategory of keys) {
            const impactKeys = Object.keys(pointsOrganizedByLikelihood[likelihoodCategory]);
            for (const impactCategory of impactKeys) {
                let index = 0; //used to determine if left, right, or center and magnitude
                let magnitude = 0;
                const increment = 0.15;
                for (const vector of pointsOrganizedByLikelihood[likelihoodCategory][impactCategory]) {
                    pointsOrganizedByLikelihood[likelihoodCategory][impactCategory][index] = {
                        ...vector,
                        likelihood_plotting_value: index % 2 === 0 ? vector.scored_vector_likelihood_score + (magnitude) : vector.scored_vector_likelihood_score + (-1 * magnitude)
                    }

                    magnitude = index % 2 === 1 ? magnitude : magnitude + increment;
                    index = index + 1;
                    //don't go too high. only allow 0.4 amount of total spreading then take the poison of overlapping
                    //because as of aug 2021, if you go higher than that it could bleed into another likelihood category and spreading is no longer defensibly ambiguous
                    if(magnitude > 0.4) {
                        magnitude = 0;
                    }
                }
            }

        }
        // console.log("organized vectors now given display likelihoods", pointsOrganizedByLikelihood);

        const displayAdjustedVectorArray = []
        for(const likelihoodCategory of keys) {
            const impactKeys = Object.keys(pointsOrganizedByLikelihood[likelihoodCategory]);
            for (const impactCategory of impactKeys) {
                for (const vector of pointsOrganizedByLikelihood[likelihoodCategory][impactCategory]) {
                    displayAdjustedVectorArray.push(vector)
                }
            }
        }

        // console.log("reorganized vectors in to a flat array", displayAdjustedVectorArray);

        return displayAdjustedVectorArray;
    } else {
        return null
    }
}

const CustomizedDot = (props) => {
    const { cx, cy, stroke, payload, value } = props;
    // console.log("in CustomizedDot payload", payload, "value", value)
    const dot = <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>
    const color = bbTranslateBreachRiskScoreToColor(payload && payload.score, true)

        return (
            <svg x={cx - 10} y={cy - 10} width={15} height={15} fill={color} viewBox="0 0 100 100">
                {dot}
            </svg>
        );

};

const RenderLineChart = ({
                             showVectorRiskScore = false,
                             useTheseEntitiesInstead = false,
                             showSlimView = false,
                            forceHeightOf = false,
                         }
    ) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);
    // const customer = customers ? customers[customerInView] : null;
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    // const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    console.log("PortfolioEntityRisk2DScatterPlot got this useTheseEntitiesInstead",useTheseEntitiesInstead);
    const safeEntitiesInstead = useTheseEntitiesInstead && bbIsObject(useTheseEntitiesInstead) ? useTheseEntitiesInstead : null;

    const entities = safeEntitiesInstead ? safeEntitiesInstead : portfolios && portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities : null;
    console.log("PortfolioEntityRisk2DScatterPlot here are the entities that will be used: ", entities);

    const isUserAllowedToSeeDataInThisTable = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", entityInView);

    // let historyData = myEntity ? myEntity.history : null;

    //grab the scored_vector_impact_score and scored_vector_likelihood_score from each entity
    let companyChartData = [];
    for (const entity in entities) {
        const myEntity = entities[entity];
        const lastCycle = myEntity.last_cycle;
        // console.log("Should push ", myEntity.name, "vector to the Portfolio risk chart?", lastCycle);
        if (lastCycle) {
            const dataToPush = {
                scored_vector_impact_score: lastCycle.scored_vector_impact_score ? lastCycle.scored_vector_impact_score : 0.71, //if there is non (i.e. null), then make it be sqrt(0.5) because that would result in a score of 1.0
                scored_vector_likelihood_score: lastCycle.scored_vector_likelihood_score ? lastCycle.scored_vector_likelihood_score : 0.71, //if there is non (i.e. null), then make it be sqrt(0.5)
                score: lastCycle.score,
                confidence_high: lastCycle.confidence_high,
                confidence_low: lastCycle.confidence_low,
                id: lastCycle.scored_vector,
                name: myEntity.name,
            }
            // console.log("Adding ", myEntity.name, "vector to the Portfolio risk chart.", "dataToPush", dataToPush);
            companyChartData.push(dataToPush)
        }
    }


    // const vectorChartData = lastCycle && lastCycle.vectors ? Object.keys(lastCycle.vectors).map((k) => lastCycle.vectors[k]) : [];
    console.log("PortfolioEntityRisk2DScatterPlot here is the initial chart data: ", companyChartData);
    const companyChartDataWithArtificialSpacing = vectorDataSpacer(companyChartData);

    return <Widget styleName={`px-1 py-1 m-0 animated fadeIn animation-duration-5 dataTile`}>
        {!showSlimView &&
            <>
                <Tooltip disableFocusListener
                         title={"Each point on the chart represents the most dangerous threat from each company in the portfolio. The BreachRisk™ Score of that company is trending towards that point."}>
                    <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                                   className={`text-muted`}/>
                </Tooltip>
                <div className="row" id={"tourAllCompaniesRow"}>
                    <div className={"col-12"} >
                        <h1 className={"text-center"}>Risk Chart: Company Top Risks</h1>
                        <p className={"text-center"}>Each company imposes risk to your portfolio. The most dangerous threat from each company is shown below.</p>


                    </div>
                </div>
            </>
        }

        <div className="row" style={{height: forceHeightOf ? forceHeightOf : 283}}>


                <div className={"col-12"} id={"tourRiskScatterPlot"}>
                    <BBDisableChildren
                        isDisabled= {true} //{isUserAllowedToSeeDataInThisTable}
                        brLevelRequired= {"infoLevel2"}
                        blurLevel={(isCurrentUserMemberOf(authUser, "admin")|| isCurrentUserMemberOf(authUser, "staff")) ? 0 : 5}
                    >
                    {!portfolios || loadingPortfolios[customerIdToUse] ?
                        <Skeleton count={10}/>
                        : !entities || loadingPortfoliosError[customerIdToUse] ?
                            <div className={"text-center"}>
                                {bbErrorSection("80px")}
                            </div>
                            :
                                <ResponsiveContainer>
                                    <ScatterChart width={800} height={400} data={companyChartDataWithArtificialSpacing ? companyChartDataWithArtificialSpacing : null}
                                                   margin={{top: 2, right: 2, left: -20, bottom: 0}}>

                                        <Scatter name="A school" data={companyChartDataWithArtificialSpacing} fill="#8884d8" shape={<CustomizedDot />}/>
                                        <CartesianGrid stroke="#ccc" strokeDasharray="3 3"/>
                                        {/*<ReChartsTooltip />*/}
                                        <ReChartsTooltip content={<CustomTooltip/>}/>
                                        <XAxis type={"number"} dataKey={"likelihood_plotting_value"} name={"likelihood"} allowDecimals={false} domain={[0,6]} ticks={[2, 4]} tickFormatter={(a,b)=> ""} >
                                            <Label value="Likelihood" offset={0} position="center" />
                                        </XAxis>
                                        <YAxis label={{ value: 'Impact', angle: -90, position: 'center' }} type={"number"} dataKey={"scored_vector_impact_score"} name={"impact"} domain={[0,6]} ticks={[2, 4]} tickFormatter={(a,b)=> ""}/>

                                    </ScatterChart>
                                </ResponsiveContainer>
                    }
                    </BBDisableChildren>
                </div>


        </div>

    </Widget>
};

export default RenderLineChart;